exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-buttons-components-IconButton-___styles__icon-button___pUjzY {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  padding: 0.3571rem;\n  background: transparent;\n  outline: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none; }\n\n.src-modules-buttons-components-IconButton-___styles__icon-button___pUjzY:focus {\n  outline: none; }\n", ""]);

// Exports
exports.locals = {
	"icon-button": "src-modules-buttons-components-IconButton-___styles__icon-button___pUjzY"
};